// 25 TON-032: the console's sentences are ICU messages in packages/content/locales/en-GB/admin.json,
// never text joined from pieces (lint TON-T08).
import { createContent, type MessageValue } from '@fairway/content';

const content = createContent();

/** A message of the `admin` namespace, by its key under `admin:`. */
export function adminText(
  key: string,
  values: Readonly<Record<string, MessageValue>> = {},
): string {
  return content.t(`admin:${key}`, values);
}

/** A length stored in metres, shown in yards (25 TON-033: the unit word comes from the units file). */
export function adminLength(metres: number | null | undefined): string {
  return typeof metres === 'number' && Number.isFinite(metres) ? content.length(metres) : '—';
}
